import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { TranslatePipe } from 'pipes/translate.pipe';
import { DateService } from 'services/date.service';

@Pipe({
	name: 'customDate'
})
export class CustomDatePipe extends NativeDateAdapter implements PipeTransform {

	private datePipe: DatePipe;

	constructor(private readonly translate: TranslatePipe, private readonly dateService: DateService) {
		super(translate.languageService.isoCode);

		this.datePipe = new DatePipe(translate.languageService.isoCode);
	}

	transform(date?: Date | number | string, format?: string): string {
		if (!date) return '';
		if (typeof date === 'number') date = new Date(date);
		if (!format || format === 'default')
			format = DateFormats.DATETIME;

		switch (format) {
			case 'system':
			case 'timezone':
				return this.datePipe.transform(this.dateService.getLocalDate(date), DateFormats.DATETIME_TIMEZONE) as string;
			case 'shortDate':
				return this.datePipe.transform(this.dateService.getLocalDate(date), DateFormats.DATE_SHORT) as string;
			case 'shortDateText':
				return this.datePipe.transform(this.dateService.getLocalDate(date), DateFormats.DATE_SHORT_TEXT) as string;
			case 'time':
				return this.datePipe.transform(this.dateService.getLocalDate(date), DateFormats.TIME) as string;
			case 'shortTime':
				return this.datePipe.transform(this.dateService.getLocalDate(date), DateFormats.TIME_SHORT) as string;
			case 'fullTime':
				return this.datePipe.transform(this.dateService.getLocalDate(date), DateFormats.TIME_FULL) as string;
			case 'fullDateTime':
				return this.datePipe.transform(this.dateService.getLocalDate(date), this.translate.transform('general.full-date-time')) as string;
			case 'fullDate':
				return this.datePipe.transform(this.dateService.getLocalDate(date), this.translate.transform('general.full-date')) as string;
			case 'daysDifferAbs':
				return Math.abs(this.dateService.getDiffInDays(date, new Date)).toString();
			case 'daysDiffer':
				return this.dateService.getDiffInDays(date, new Date).toString();
			case 'sortable':
			case 'iso8601':
				return this.datePipe.transform(this.dateService.getLocalDate(date), DateFormats.DATE_ISO8601) as string;
			case 'stripped':
				return this.datePipe.transform(this.dateService.getLocalDate(date), DateFormats.DATETIME_STRIPPED) as string;
		}
		
		return this.datePipe.transform(this.dateService.getLocalDate(date), format) as string;
	}
	
	format(date: Date): string {
		return this.transform(date, 'shortDate');
	}
	getFirstDayOfWeek(): number {
		return 1;
	}
}

export class DateFormats {
	static readonly DATETIME = 'dd.MM.yyyy HH:mm';
	static readonly DATETIME_TIMEZONE = 'dd.MM.yyyy HH:mm:ss.SSS zzz';
	static readonly DATETIME_STRIPPED = 'yyyyMMddHHmmss';
	static readonly DATE_SHORT = 'dd.MM.yyyy';
	static readonly DATE_SHORT_TEXT = 'd. MMMM yyyy';
	static readonly DATE_ISO8601 = 'yyyy-MM-dd';
	static readonly TIME = 'HH:mm:ss';
	static readonly TIME_SHORT = 'HH:mm';
	static readonly TIME_FULL = 'HH:mm:ss.SSS';
}
